import CustomBreadcrumb from '@/components/custom-breadcrumb/custom-breadcrumb';
import { PersonalInfo } from '@/components/personal-info/personal-info';
import { Security, SecurityFieldType } from '@/components/security/security';
import { Tab } from '@/components/tab/tab';
import { useAuth } from '@/hooks/use-auth/use-auth';
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs/use-breadcrumbs';
import { useUser } from '@/hooks/use-user/use-user';

import { Flex } from 'antd';

export function Profile() {
  const items = useBreadcrumbs();
  const { userData } = useUser();
  const { changePasswordForLoggedUser, errorChangePassword, isPendingChangePassword } = useAuth();

  const handleSubmit = ({ currentPassword, newPassword }: SecurityFieldType) => {
    changePasswordForLoggedUser({
      user: {
        password: newPassword,
        password_confirmation: newPassword,
        current_password: currentPassword,
      },
    });
  };

  const { first_name = '--', last_name = '--', email = '--', phone = 'n/a' } = userData || {};

  const tabItems = [
    {
      key: 'personal-info',
      label: 'Personal Info',
      children: (
        <PersonalInfo first_name={first_name} last_name={last_name} email={email} phone={phone} />
      ),
    },
    {
      key: 'security',
      label: 'Security',
      children: (
        <Security
          onSubmit={handleSubmit}
          isLoading={isPendingChangePassword}
          error={errorChangePassword || ''}
        />
      ),
    },
  ];

  return (
    <Flex vertical>
      <CustomBreadcrumb items={items} />
      <Tab items={tabItems} />
    </Flex>
  );
}
